import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ProfessionalHeading from "./ProfessionalHeading";
import "./Hero.css";
import { Link } from "react-router-dom";

import hero1 from "../assets/about1.jpeg";
import hero2 from "../assets/about1.jpg";
import hero3 from "../assets/about2.jpeg";
import hero4 from "../assets/about2.jpg";

function Hero() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
      easing: "ease-out",
    });
  }, []);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % 4);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slides = [
    {
      id: 1,
      img: hero1,
      headline: "BNI Members — 8 Years of Trusted Business Networks",
      subline:
        "Fast partnerships and valuable contacts across industries — we connect projects to the right people.",
      cta: "Partner With Us",
    },
    {
      id: 2,
      img: hero2,
      headline: "Authorized Service Partner — Samsung, Daikin",
      subline:
        "Genuine parts, certified technicians, and brand-compliant service standards.",
      cta: "Book Authorized Service",
    },
    {
      id: 3,
      img: hero3,
      headline: "We Partner With Engineers & Big Brands",
      subline:
        "End-to-end commercial project execution and reliable B2B tie-ups. Let’s build large-scale HVAC solutions together.",
      cta: "Discuss Your Project",
    },
    {
      id: 4,
      img: hero4,
      headline: "We Are a Manufacturer of Precision Duct Units",
      subline:
        "Duct Factory Unit – Precision. Performance. Perfection.",
      details:
        "Located in Coimbatore, our fabrication unit produces spiral ducts, rectangular ducts, flat ducts, L-shaped ducts, and collar fittings with high-accuracy engineering.",
      cta: "Explore Duct Factory",
    },
  ];

  return (
    <section className="hero-section">

      {/* BACKGROUND IMAGE CHANGES PER SLIDE */}
      <div className="hero-bg">
        <div className="left-white"></div>

        <div className="right-img">
          <img src={slides[index].img} alt="Hero Banner" />
          <div className="right-gradient"></div>
        </div>
      </div>

      <div className="hero-content">
        <div
          key={slides[index].id}
          className="text-box"
          data-aos="fade-right"
        >
          <span className="small-title">Premium AC Service & Repair</span>
          <br /><br />

          <h1 className="hero-heading">{slides[index].headline}</h1>

          <p className="sub-line" style={{ fontSize: "17px", marginTop: "10px" }}>
            {slides[index].subline}
          </p>

          {slides[index].details && (
            <p style={{ marginTop: "10px", fontSize: "15px", opacity: 0.8 }}>
              {slides[index].details}
            </p>
          )}

          <br />

          <Link to="/contact" className="hero-btn">
            {slides[index].cta} →
          </Link>
        </div>
      </div>

      {/* DOT INDICATORS */}
      <div
  className="carousel-dots"
  style={{
    position: "absolute",
    bottom: "40px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "10px",
  }}
>
        {slides.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            style={{
              width: i === index ? "12px" : "8px",
              height: i === index ? "12px" : "8px",
              borderRadius: "50%",
              background: i === index ? "#f97316" : "#999",
              cursor: "pointer",
              transition: "0.3s",
            }}
          ></div>
        ))}
      </div>
    </section>
  );
}

export default Hero;
